import React from 'react';
import { withTheme } from 'styled-components';
export var EnergiaIcon = function EnergiaIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "158px",
    height: "266px",
    viewBox: "0 0 158 266",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Energi\u0301a"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Energi\u0301a",
    transform: "translate(-108.000000, -1.000000)",
    fill: theme.colors.primary,
    fillRule: "nonzero"
  }, React.createElement("g", {
    id: "Energ\xEDa",
    transform: "translate(108.000000, 1.000000)"
  }, React.createElement("g", {
    id: "Group"
  }, React.createElement("path", {
    d: "M157.14,93.82 C156.09,91.86 154.04,90.63 151.82,90.63 L106.97,90.63 L145.22,8.66 C146.09,6.79 145.95,4.6 144.84,2.86 C143.73,1.12 141.81,0.07 139.75,0.07 L73.34,0.07 C70.01,0.07 67.3,2.77 67.3,6.11 C67.3,9.45 70,12.15 73.34,12.15 L130.27,12.15 L92.02,94.12 C91.15,95.99 91.29,98.18 92.4,99.91 C93.51,101.65 95.43,102.7 97.49,102.7 L140.54,102.7 L55.52,230.23 L73.21,146.2 C73.58,144.42 73.14,142.56 71.99,141.15 C70.84,139.74 69.12,138.92 67.3,138.92 L15.08,138.92 L54.97,7.86 C55.94,4.67 54.14,1.3 50.95,0.33 C47.77,-0.63 44.39,1.16 43.42,4.35 L1.15,143.2 C0.59,145.03 0.93,147.01 2.07,148.55 C3.21,150.08 5.01,150.99 6.92,150.99 L59.85,150.99 L37.24,258.41 C36.64,261.24 38.14,264.1 40.81,265.22 C41.57,265.54 42.36,265.69 43.14,265.69 C45.11,265.69 47.02,264.72 48.17,263 L156.84,100 C158.07,98.16 158.19,95.78 157.14,93.82 Z",
    id: "Path"
  }), React.createElement("path", {
    d: "M49.49,58.53 L31.38,112.86 C30.32,116.03 32.03,119.45 35.2,120.5 C35.83,120.71 36.48,120.81 37.11,120.81 C39.64,120.81 41.99,119.21 42.84,116.68 L60.95,62.35 C62.01,59.18 60.3,55.76 57.13,54.72 C53.96,53.66 50.55,55.37 49.49,58.53 Z",
    id: "Path"
  }))))));
};
export default withTheme(EnergiaIcon);